{
  "lang": "ES",
  "current_language": "ES",
  "meta": {
    "title": "La primera membresía financiera para migrantes modernos. - MAJORITY",
    "description": "Por fin, una aplicación todo en uno para administrar tu dinero, enviar transferencias y hacer llamadas internacionales. ¡Hazte miembro para recibir tu Tarjeta de Débito MAJORITY Visa® y desbloquear todos los beneficios!"
  },
  "page_labels": {
    "services": "Servicios",
    "majority_account": "Cuenta de MAJORITY",
    "majority_account_no_ssn": "No tienes SSN",
    "majority_account_subtitle": "Asegurada por la FDIC",
    "debit_card": "Tarjeta de débito Visa®",
    "features_debit_card_no_ssn": "No tienes SSN",
    "debit_card_subtitle": "Compra y recibe cashback",
    "money_transfers": "Envíos de dinero",
    "money_transfers_subtitle": "Tipos de cambio competitivos",
    "mobile_top_ups": "Recargas móviles",
    "mobile_top_ups_subtitle": "Sin cargos y entrega inmediata",
    "international_calling": "Llamadas internacionales",
    "international_calling_subtitle": "Gratis en más de 20 países",
    "personal_advisor": "Asesores personales",
    "community": "Comunidad",
    "help": "Ayuda",
    "contact_us": "Contáctanos",
    "company": "Empresa",
    "about": "Quiénes somos",
    "press": "Prensa",
    "careers": "Bolsa de trabajo",
    "advisor": "Asesor",
    "terms_and_conditions": "Condiciones de uso",
    "complaints": "Quejas",
    "majority_tv": "MAJORITY TV",
    "legal": "Información legal",
    "legal_terms_of_use": "Términos de uso",
    "migrant_handbook": "Guía del Migrante",
    "no_snn": "¿No tienes SSN? No hay problema",
    "locations": "Ubicaciones",
    "banking": "Banca",
    "m_pay": "MAJORITY Pay",
    "help_center": "Centro de ayuda",
    "m_pay_subtitle": "Paga a miembros al instante",
    "migrant_handbook_subtitle": "Aprende a prosperar en USA",
    "locations_subtitle": "Visítanos",
    "help_center_subtitle": "Contacto y preguntas frecuentes"
  },
  "label": {
    "suggested": "Sugeridos",
    "global": "Global",
    "app": "App",
    "language": "Idioma",
    "terms_and_conditions": "Términos y condiciones",
    "privacy_policy": "Política de privacidad",
    "all_rights_reserved": "Todos los derechos reservados.",
    "loading": "Cargando",
    "no_country_found": "No se encontró país",
    "name": "Nombre",
    "email": "Correo electrónico",
    "phone": "Teléfono",
    "faq": "Preguntas frecuentes",
    "features": "Funciones",
    "account": "Cuenta MAJORITY",
    "calling": "Llamadas internacionales",
    "community": "Comunidad",
    "help": "Ayuda",
    "about_us": "Quiénes somos",
    "contact_us": "Contáctanos",
    "contact_info": "Datos de contacto",
    "company": "Empresa",
    "press": "Prensa",
    "careers": "Bolsa de trabajo",
    "done": "OK",
    "search": "Buscar",
    "search_country": "Buscar país",
    "home": "Inicio",
    "home_page": "Página de inicio",
    "unlimited": "Ilimitado",
    "install_majority": "Instalar App de MAJORITY",
    "install": "Instalar",
    "get": "Obtén",
    "yes": "Sí",
    "no": "No",
    "close": "Cerrar",
    "rate": "Tarifa",
    "mobile_landline": "Teléfonos móviles y fijos",
    "perMinute": "/min",
    "service": "Servicio",
    "our_rates": "Nuestras tarifas",
    "see_offer_for": "Ver la oferta de",
    "choose_a_country": "Elige un país",
    "enter_number": "Número",
    "all": "Todos",
    "show_more": "Mostrar más",
    "ends": "Finaliza",
    "location": "Ubicación",
    "categories": "Categorías",
    "all_discounts": "Todos los descuentos",
    "multiple": "Varias",
    "see_all": "Ver todo",
    "show_all": "Mostrar todo",
    "articles": "Artículos",
    "events": "Eventos",
    "discounts": "Descuentos",
    "download": "Descarga App",
    "download_majority": "Descarga MAJORITY",
    "edit": "Editar",
    "optional": "opcional"

  },
  "selector": {
      "select_community": "SELECCIONA UN PAÍS",
      "select_community_details": "¿De dónde eres? Adaptaremos tu experiencia a tu país de orígen.",
      "select_language": "SELECCIONA UN IDIOMA",
      "confirm_button": "Confirmar"
  },
  "dropdown": {
    "placeholder": "Selecciona un elemento",
    "empty_placeholder": "No se encontraron elementos",
    "select_community": "Comunidad"
  },
  "footer": {
    "disclaimer": [
      "La app de MAJORITY brinda los servicios bancarios a través de Axiom Bank, N.A. miembro de la FDIC.",
      "La tarjeta MAJORITY es emitida por Axiom Bank, N.A. miembro de la FDIC, conforme a una licencia de Visa U.S.A. Inc.",
      "Las transacciones pueden estar sujetas a límites impuestos por la legislación aplicable, incluida la Ley de Secreto Bancario y las leyes contra el lavado de dinero. Consulta nuestros términos y condiciones para obtener más información.",
      "<br/>El Comisionado de Regulación Financiera del Estado de Maryland (<a href='https://www.dllr.state.md.us/finance/consumers/comphow.shtml' class='underline' target='_blank'>The Commissioner of Financial Regulation for the State of Maryland</a>) aceptará todas las preguntas o quejas de los residentes de Maryland con respecto a Majority Payment Services LLC (NMLS # 1991596) en 1100 North Eutaw Street, Suite 611, Baltimore, MD 21201, teléfono 888-784-0136.",
      "<br/>Los servicios pueden ser proporcionados por Majority Payment Services LLC (NMLS # 1991596). Esta empresa con licencia puede ser verificada a través del sitio web de acceso para consumidores del NMLS: <a href='https://www.nmlsconsumeraccess.org/' class='underline' target='_blank'>https://www.nmlsconsumeraccess.org/</a><br/><br/>"
    ],
    "address": "MAJORITY, 2509 N. Miami Avenue #101, Miami, Florida 33127"
  },
  "action": {
    "submit": "Enviar",
    "get_started": "Comenzar",
    "read_more": "Obtener más información",
    "learn_more": "Leer más",
    "view_all": "Ver todo",
    "sign_up": "Registrarse"
  },
  "reviews": {
    "title": "Lo que dice la gente"
  },
  "download_app": {
    "title": "Gasta, envía y habla en una sola app",
    "body": "Descarga MAJORITY y obtén todas las soluciones que necesitas en un solo lugar.",
    "placeholder": "Número de teléfono",
    "download_here": "O descárgalo aquí",
    "disclaimer": "Para obtener más información sobre cómo recopilamos y usamos tu información, consulta nuestra <a class=\"{variant}\" href=\"{privacy_policy_link}\">política de privacidad</a>",
    "success": {
      "title": "¡Genial!",
      "body": "Acabamos de enviarte un texto con un enlace para descargar MAJORITY. Haz clic en el enlace para obtener la app y sigue las instrucciones para hacerte miembro de MAJORITY."
    }
  },
  "shared": {
    "cookie_banner": "Utilizamos cookies para mejorar tu experiencia",
    "cookie_consent_message": "Al aceptar cookies no esenciales, podemos brindarte una experiencia de navegación personalizada en nuestro sitio web. Obtén más información en nuestra <a class=\"{classes}\" href=\"{link}\">Política de Privacidad</a>.",
    "cookie_consent_accept": "Aceptar todo",
    "cookie_consent_decline": "Rechazar no esenciales",
    "no_ssn_banner": "¿No tienes SSN? No hay problema. Obtén más información",
    "mtu_calculator": {
      "body": "Comparte créditos con tus seres queridos en tu país, ¡sin cargos!",
      "cta": "Ver tarifas",
      "calculator_title": "¿Para quién es la recarga?",
      "calculator_recommended": "Oferta recomendada",
      "calculator_all_offers": "Todas las ofertas",
      "calculator_bonus": "Bono",
      "calculator_valid": "Válida hasta",
      "calculator_show_more_button": "Ver más opciones",
      "calculator_show_less_button": "Ver menos opciones",
      "calculator_error": "No reconocemos este número. Intenta con otro.",
      "calculator_fee_for": "para"
    }
  }
}
